module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": _vm.downloadList
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]), _vm._v(" "), _c('a', {
    ref: "download",
    staticClass: "hidden",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_vm._v(_vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-693997ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/activity/DownloadParticipations.vue
// module id = 451
// module chunks = 1